import React from "react";
import clsx from "clsx";

import {DeviceStatus, STATUS_LABELS} from "./buildTree";

import classes from "./DevicesExplorer.module.scss";

const STATUS_DOT_CLASS: Record<DeviceStatus, string> = {
    healthy: classes.dotHealthy,
    offline: classes.dotOffline,
    warning: classes.dotWarning,
    alarm: classes.dotAlarm,
};

interface StatusDotProps {
    status: DeviceStatus;
}

const StatusDot: React.FC<StatusDotProps> = ({status}) => (
    <span className={clsx(classes.rowStatusDot, STATUS_DOT_CLASS[status])} title={STATUS_LABELS[status]}/>
);

export default StatusDot;
